<template>
  <el-card v-loading="loading">
    <div v-if="userType !== 0">
      <el-row>
        <!-- <el-button type="primary" size="mini" @click="transferAmount">{{
          $t('btns.transferAmount')
        }}</el-button> -->
      </el-row>
      <p class="number-amount">
        <span>{{ $t('merchantdeposit.label.amountTotal') }}</span>
        <span>{{ (allAmount || 0) | toThousands }}</span>
      </p>
      <el-row style="margin-bottom: 30px">
        <el-steps :active="active" finish-status="success" simple>
          <el-step :title="$t('merchantdeposit.steps.one')"></el-step>
          <el-step :title="$t('merchantdeposit.steps.three')"></el-step>
          <!-- <el-step :title="$t('merchantdeposit.steps.three')"></el-step> -->
        </el-steps>
      </el-row>
      <!-- /* ---------------------------------- 提现表单 ---------------------------------- */ -->
      <el-row v-if="active === 0">
        <el-form :model="form" v-bind="formProps.form">
          <el-form-item prop="bankId" :label="$t('merchantdeposit.label.bankId')">
            <el-autocomplete
              style="width: 500px"
              v-model="withdrawBank"
              :fetch-suggestions="querySearch"
              :placeholder="$t('accountmanager.selectbank')"
              @select="handleSelect"
            />

            <!--            <el-select v-model="form.bankId" size="mini" style="width: 366px">-->

            <!--              <el-option-->
            <!--                v-for="item in bankData"-->
            <!--                :key="item.bankNo"-->
            <!--                :label="`${item.bankNo}-${item.bankAccount}-${item.bankName}`"-->
            <!--                :value="item.id"-->
            <!--              >-->
            <!--              </el-option>-->
            <!--              <el-option :label="$t('btns.emptyValue')" value=""></el-option>-->
            <!--            </el-select>-->
          </el-form-item>

          <el-form-item :label="$t('merchantdeposit.label.blanceAmount')">
            <el-input :disabled="true" :value="blanceAmount | toThousands"> </el-input>
          </el-form-item>

          <el-form-item
            v-if="form.walletType"
            prop="withdrawAmount"
            :label="$t('merchantdeposit.label.withdrawAmount')"
          >
            <el-input
              v-model="form.withdrawAmount"
              min="1000"
              onkeyup="value=value.replace(/[^[0-9]]+/, '')"
            ></el-input>
          </el-form-item>
        </el-form>

        <el-row>
          <el-button
            type="primary"
            style="width: 100%"
            :disabled="allAmount < 1000"
            @click="doAuth(1)"
          >
            {{ $t('btns.next') }}
          </el-button>
        </el-row>
      </el-row>
      <el-row v-if="active === 1">
        <el-form :model="form" v-bind="formProps.form1">
          <el-form-item
            prop="googleDynamicCaptcha"
            :label="$t('merchantdeposit.label.googleDynamicCaptcha')"
          >
            <el-input
              v-model="form.googleDynamicCaptcha"
              maxlength="6"
              minlength="6"
              onkeyup="value=value.replace(/[^\d]+/, '')"
            ></el-input>
          </el-form-item>

          <el-form-item prop="payPass" :label="$t('merchantdeposit.label.payPass')">
            <el-input type="password" v-model="form.payPass"></el-input>
          </el-form-item>
        </el-form>

        <el-row>
          <!-- <el-button type="primary" style="width: 100%" @click="doAuth(2)">
            {{ $t('btns.next') }}
          </el-button> -->
          <el-button type="primary" style="width: 100%" @click="doAuth(3)">
            {{ $t('btns.confirm') }}
          </el-button>
        </el-row>
      </el-row>
      <!-- <el-row v-if="active === 2">
        <el-form :model="form" v-bind="formProps.form2"> </el-form>

        <el-row> </el-row>
      </el-row> -->
      <!-- /* -------------------------------- google未认证 ------------------------------- */ -->
      <el-dialog :visible.sync="dialogVisible" width="30%">
        <span>{{ $t('withdraw.tips.google') }}</span>

        <el-row slot="footer">
          <el-button type="primary" @click="googleBind()">{{ $t('btns.confirm') }}</el-button>
        </el-row>
      </el-dialog>
    </div>
    <!-- /* ----------------------- @TODO 更了tip为： 不是代理或商户，不能提现 ----------------------- */ -->
    <div v-else>{{ $t('withdraw.tips.tip') }}</div>
  </el-card>
</template>

<script>
import { isNumber, betweenLenNumber } from '@/utils/validate';
import merchantdepositApi from '@/api/merchantdeposit';
import { mapState } from 'vuex';
export default {
  // name: 'merchantdeposit',
  data() {
    return {
      loading: true,
      dialogVisible: false,
      active: 0,
      form: {
        bankId: '',
        googleDynamicCaptcha: '',
        payPass: '',
        walletType: 'all',
        withdrawAmount: ''
      },

      bankData: [],

      allAmount: 0,
      merchant: {},

      withdrawBank: ''
    };
  },
  computed: {
    ...mapState({
      userType: ({ user }) => user.info.userType,
      userName: ({ user }) => user.info.userName
    }),
    blanceAmount() {
      return this.allAmount - this.form.withdrawAmount < 0
        ? 0
        : this.allAmount - this.form.withdrawAmount;
    },
    amountObj() {
      return { all: this.allAmount };
    }
  },
  created() {
    this.init();
  },
  mounted() {
    if (this.userType !== 0) {
      this.initData();
    }
  },
  methods: {
    initData() {
      this.getSummary();

      this.getBank();
      this.getmerchantNo();
    },
    init() {
      /* ----------------------------- element -props ----------------------------- */
      this.formProps = {
        form: {
          ref: 'form1',
          inline: false,
          size: 'small',
          rules: {
            bankId: {
              required: true,
              message: this.$t('merchantdeposit.rules.bankId.required'),
              trigger: 'change'
            },

            walletType: {
              required: true,
              message: this.$t('merchantdeposit.rules.walletType.required'),
              trigger: 'change'
            },
            withdrawAmount: [
              {
                required: true,
                validator: (rules, value, cb) => {
                  if (!isNumber(value)) {
                    cb(new Error(this.$t('merchantdeposit.rules.withdrawAmount.type')));
                  } else if (value < 1000) {
                    cb(new Error(this.$t('merchantdeposit.rules.withdrawAmount.min')));
                  } else if (value > this.allAmount) {
                    cb(new Error(this.$t('merchantdeposit.rules.withdrawAmount.max')));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
            ]
          }
        },
        form1: {
          ref: 'form3',
          inline: true,
          size: 'small',
          rules: {
            googleDynamicCaptcha: [
              {
                required: true,
                message: this.$t('merchantdeposit.rules.googleDynamicCaptcha.required'),
                trigger: 'blur'
              },
              {
                validator: (rules, value, cb) => {
                  if (!isNumber(value)) {
                    cb(new Error(this.$t('merchantdeposit.rules.googleDynamicCaptcha.type')));
                  } else if (!betweenLenNumber(6, 6, value)) {
                    cb(new Error(this.$t('merchantdeposit.rules.googleDynamicCaptcha.max')));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
            ],
            payPass: {
              required: true,
              message: this.$t('merchantdeposit.rules.payPass.required'),
              trigger: 'blur'
            }
          }
        },
        form2: {
          ref: 'form3',
          inline: true,
          size: 'small',
          rules: {}
        }
      };
    },

    /* ---------------------------------- 获取数据 ---------------------------------- */
    async getSummary() {
      const params = {
        merchantNo: this.userName
      };
      const { data } = await merchantdepositApi.getSummary(params);
      if (data) {
        if (data.code === 200) {
          this.allAmount = data.data.allWalletBalance;
        } else {
          this.$message.error(data.msg);
        }
        this.loading = false;
      }
    },
    async transferAmount() {
      if (!this.userName) return;
      this.loading = true;
      let { data } = await merchantdepositApi.doTransfer({ merchantNo: this.userName });
      if (data && data.code == 200) {
        this.$message.success(this.$t('status.success'));
        this.getSummary();
      } else {
        this.$message.error(data.msg || 'Network error!');
      }
      this.loading = false;
    },
    async getBank() {
      const params = {
        merchatNo: this.userName
      };
      const { data } = await merchantdepositApi.getBank(params);
      if (data && data.code === 200) {
        this.bankData = data.data || {};
      } else {
        this.$message.error(data.msg);
      }
    },
    async getmerchantNo() {
      if (this.userType === 2) {
        const merchantNo = this.userType === 2 ? this.userName : '';
        const params = { merchantNo };
        const { data } = await merchantdepositApi.getmerchantNo(params);
        if (data && data.code === 200) {
          this.merchant = data.data;
          this.$store.commit('SET_CLIENTDATA', data.data);
          this.dialogVisible = this.merchant.googleAuthStatus === 0;
        } else {
          this.$message.error(data.msg);
        }
      }
    },

    doAuth(step) {
      if (this.merchant.googleAuthStatus === 0) {
        this.googleBind();
        return;
      }

      this.$refs[`form${step}`].validate((valid) => {
        if (valid) {
          if (step === 1) {
            this.active = step;
          }
          if (step === 2) {
            merchantdepositApi
              .getAuth({ code: this.form.googleDynamicCaptcha })
              .then(({ data }) => {
                if (data && data.code === 200) {
                  this.active = step;
                } else {
                  this.$message.error(data.msg);
                }
              });
          }
          if (step === 3) {
            merchantdepositApi.doWithdraw(this.form).then(({ data }) => {
              if (data && data.code === 200) {
                this.initData();
                /**
                 * 初始化状态
                 */
                this.active = 0;
                this.withdrawBank = '';
                this.form = {
                  bankId: '',
                  googleDynamicCaptcha: '',
                  payPass: '',
                  walletType: 'all',
                  withdrawAmount: ''
                };
                this.$message.success(this.$t('status.success'));
              } else {
                this.$message.error(data.msg);
              }
            });
          }
        }
      });
    },
    googleBind() {
      this.dialogVisible = false;
      this.$router.push({ name: 'safeCenter' });
    },

    querySearch(queryString, cb) {
      const banks = this.bankData.map((bank) => ({
        value: `${bank.bankNo}-${bank.bankAccount}-${bank.bankName}`,
        id: bank.id
      }));
      const results = queryString ? banks.filter(this.createFilter(queryString)) : banks;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (bank) => bank.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    handleSelect(item) {
      this.form.bankId = item.id;
      console.log(item, this.form.bankId);
    }
  }
};
</script>

<style lang="scss" scoped>
.number-amount {
  background-color: rgba($color: #000000, $alpha: 0.2);
}

.wrapper-amount {
  padding-top: 30px;
  .list-card {
    list-style: none;
    display: flex;
    padding-left: 0;
    .li-card {
      &:nth-child(n + 2) {
        margin-left: 10px;
      }

       .el-radio {
        display: flex;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/merchantdeposit/index.vue